import React, { FC } from 'react';
import SwiperCore, { A11y, Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { PromoPanelSingleType } from '../../../models/promo-panel-single-type';
import { PromoPanelType } from '../../../models/promo-panel-type';
import PromoPanelSingle from '../../molecules/promo-panel-single/promo-panel-single';

SwiperCore.use([A11y, Autoplay, Pagination]);

const PromoPanel: FC<PromoPanelType> = ({
  promoPanelItems,
}: PromoPanelType) => {
  return (
    <div className="lg:mb-24">
      <Swiper
        a11y={{ enabled: true }}
        autoplay={{ delay: 8000, disableOnInteraction: false }}
        className="my-component-spacing lg:my-component-spacing"
        loop
        observeParents
        observer
        pagination={{ clickable: true }}
        spaceBetween={20}
        speed={500}
      >
        {promoPanelItems.map((item: PromoPanelSingleType) => (
          <SwiperSlide key={`slide-${item.heading}`}>
            {({ isActive }) => (
              <PromoPanelSingle isActive={isActive} {...item} />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default PromoPanel;
